<template>
    <header id="eng-koreit-header"
        :class="{ active: state.isMenuActive }">
        <h1 id="eng-koreit-logo"><a href="/eng-main.html" title="Go to Main"><span class="text_hidden">Koreit</span></a></h1>
        
        <!-- 상단 메뉴 -->
        <nav id="eng-koreit-gnb">
            <MenuNavigation ref="topMenu"
                :menuNavigationType="1"
                :onRootMenuClick="eventHandler.onRootMenuClick"
                :onRootMenuMouseOver="eventHandler.onRootMenuMouseOver"
                :onRootMenuMouseOut="eventHandler.onRootMenuMouseOut" />
        </nav>

        <!-- 검색, 국문, 영문 버튼 영역 -->
        <div class="h-util">
            <ul class="h-lang">
                <li><a href="#" @click="eventHandler.onKorButtonClick" title="KOR">KOR</a></li>
                <li class="on"><a href="#" @click="eventHandler.onEngButtonClick" title="ENG">ENG</a></li>
            </ul>
        </div>
        <button type="button" id="menuToggle" @click="state.isMenuActive = state.isMenuActive ? false : true"><span></span><span></span><span></span></button>

        <!-- 메뉴 맵 -->
        <div id="eng-all-gnb">
            <MenuNavigation ref="menuMap"
                :menuNavigationType="2"
                :onRootMenuClick="eventHandler.onRootMenuClick" />
        </div>
    </header>
    
    <div id="mVisu">
        <div class="mVisu_slide">
            <div class="swiper-wrapper">
                <div class="swiper-slide">
                    <div class="img_box mVisu1"></div>
                    <div class="txt_box">
                        <!-- <p class="tit">KOREIT seeks to <br class="mo_br">grow together small things.</p> -->
                        <p class="tit">Creating Value for Tomorrow</p>
                        <!-- <p class="txt">The KOREIT, which aims to be the best real estate investment <br class="mo_br">banking company in Korea, is making a new history today.</p> -->
                        <p class="txt"><strong>Korea Real Estate Investment&Trust</strong> is
                            <br class="mo_br">Korea’s leading comprehensive real estate and finance company.
                            <br class="mo_br">
                            <br class="mo_br">We are leading the real estate finance industry in South Korea
                            <br class="mo_br">with a discerning eye for the times and competitive edge.
                        </p>
                        <a href="/en/about-koreit/ceo-message" title="About Koreit">About Koreit</a>
                    </div>
                </div>
                <div class="swiper-slide">
                    <div class="img_box mVisu2"></div>
                    <div class="txt_box">
                        <p class="tit">Creating Value for Tomorrow</p>
                        <p class="txt"><strong>Korea Real Estate Investment&Trust</strong> is
                            <br class="mo_br">Korea’s leading comprehensive real estate and finance company.
                            <br class="mo_br">
                            <br class="mo_br">We are leading the real estate finance industry in South Korea
                            <br class="mo_br">with a discerning eye for the times and competitive edge.
                        </p>
                        <a href="/en/about-koreit/ceo-message" title="About Koreit">About Koreit</a>
                    </div>
                </div>
                <div class="swiper-slide">
                    <div class="img_box mVisu3"></div>
                    <div class="txt_box">
                        <p class="tit">Creating Value for Tomorrow</p>
                        <p class="txt"><strong>Korea Real Estate Investment&Trust</strong> is
                            <br class="mo_br">Korea’s leading comprehensive real estate and finance company.
                            <br class="mo_br">
                            <br class="mo_br">We are leading the real estate finance industry in South Korea
                            <br class="mo_br">with a discerning eye for the times and competitive edge.
                        </p>
                        <a href="/en/about-koreit/ceo-message" title="About Koreit">About Koreit</a>
                    </div>
                </div>
            </div>
            <div class="swiper-button-next"></div>
            <div class="swiper-button-prev"></div>
            <div class="swiper-pagination"></div>
            <div class="swiper-scrollbar"></div>
        </div>
        <div class="btn_box">
            <button type="button" title="Slide Stpp" class="stop on"><i class="fa-regular fa-pause"></i></button>
            <button type="button" title="Slide Play" class="play"><i class="fa-regular fa-play"></i></button>
        </div>

        <div class="scroll_box">
            <p>SCROLL DOWN</p>
            <i class="fa-light fa-computer-mouse-scrollwheel"></i>
        </div>
    </div>

    <div id="mService" class="inner">
        <div><a href="javascript:;" @click="eventHandler.onImgClick('img1')">
            <div class="img-box img1"></div>
            <p>Land Trust</p>
        </a></div>
        <div><a href="javascript:;" @click="eventHandler.onImgClick('img2')">
            <div class="img-box img2"></div>
            <p>Land Trust-led<br>Urban Improvement Project </p>
        </a></div>
        <div><a href="javascript:;" @click="eventHandler.onImgClick('img3')">
            <div class="img-box img3"></div>
            <p>REITs</p>
        </a></div>
        <div><a href="javascript:;" @click="eventHandler.onImgClick('img4')">
            <div class="img-box img4"></div>
            <p>Investment Business</p>
        </a></div>
    </div>

    <!-- 푸터 영역 -->
    <Footer :isKorMenuOn="state.isKorMenuOn" />
</template>
<script>
import { onMounted, reactive, ref } from '@vue/runtime-core';
import { krtBoardCommon } from '@/modules/krt-board-common.js';
// swiper 라이브러리 (우선은 4.5.0 버전 사용 필수!!)
import Swiper from 'swiper/dist/js/swiper.js';
import { useStore } from 'vuex';
import { menuType, menuDataSource } from '@/modules/menu-management.js';
import MenuNavigation from '@/components/MenuNavigation.vue';
import Footer from '@/components/Footer.vue';
export default {
    components: {
        MenuNavigation,
        Footer,
    },
    setup() {

        // 최상단 메뉴 ref
        const topMenu = ref(null);

        // 메뉴맵 ref
        const menuMap = ref(null);

        // 스토어
        const store = useStore();

        // state (변수)
        const state = reactive({

            // 국문메뉴 on 여부
            isKorMenuOn: true,

            // 영문메뉴 on 여부
            isEngMenuOn: false,

            // 상단 메뉴영역 active 여부
            isMenuActive: false,
        });

        // 이벤트 핸들러
        const eventHandler = {

            /**
             * 국문 메뉴 버튼 클릭 이벤트 처리
             */
            onKorButtonClick: event => {

                event.preventDefault();

                // 메뉴유형값 설정 (session storage)
                sessionStorage.setItem('menuType', menuType.kor);

                // 국문 메인화면으로으로 이동
                location.href = '/main.html';
            },

            /**
             * 영문 메뉴 버튼 클릭 이벤트
             */
            onEngButtonClick: event => {

                // a tag 이벤트 막기
                event.preventDefault();
            },

            /**
             * 최상위 메뉴 클릭 이벤트 처리
             * @param {any} event
             * @param {Number} menuNavigationType : 메뉴 네비게이션 유형 (1: 상단 메뉴영역, 2: 메뉴맵, 3: 사이트맵 페이지 내 메뉴 맵)
             * @param {Object} menuInfo : 메뉴 정보
             */
            onRootMenuClick: (event, menuNavigationType, menuInfo) => {

                event.target.parentNode.classList.toggle('on');
            },

            /**
             * 최상위 메뉴 마우스 오버 이벤트 처리
             */
            onRootMenuMouseOver: () => {

                document.getElementById("eng-koreit-header").classList.add('on');
            },

            /**
             * 최상위 메뉴 마우스 아웃 이벤트 처리
             */
            onRootMenuMouseOut: () => {

                document.getElementById("eng-koreit-header").classList.remove('on');
            },
            /**
             * 하단 이미지 클릭시 해당 경로로 이동
             */
            onImgClick: (type) => {
                if (type === 'img1') {
                    location.href = '/en/koreit-service/land-trust';
                }
                else if (type === 'img2') {
                    location.href = '/en/koreit-service/land-trust-led-urban-improvement-project';
                }
                else if (type === 'img3') {
                    location.href = '/en/koreit-service/reits';
                }
                else if (type === 'img4') {
                    location.href = '/en/koreit-service/investment-business';
                }
            },
        }

        const methods = {

            /**
             * 디자인 초기화 
             * -> 디자인루니에서 제공한 스크립트 우선은 사용 함 (100% 동일하진 않음, 리펙토링 가능하면 할 것!!)
             */
            designInit: () => {

                const mVisuSwiper = new Swiper(".mVisu_slide", {
                    effect: 'fade',
                    pagination: {
                        el: ".swiper-pagination",
                        type: "fraction",
                    },
                    navigation: {
                        nextEl: ".swiper-button-next",
                        prevEl: ".swiper-button-prev",
                    },
                    scrollbar: {
                        el: ".swiper-scrollbar",
                        hide: false,
                    },
                    autoplay: {
                        delay: 6000,
                        disableOnInteraction: false,
                    },
                });

                const stopBtn = document.querySelector('.btn_box .stop');
                const playBtn = document.querySelector('.btn_box .play');
                
                stopBtn.addEventListener("click", function(){
                    stopBtn.classList.remove("on");
                    playBtn.classList.add("on");
                    mVisuSwiper.autoplay.stop();
                });

                playBtn.addEventListener("click", function(){
                    playBtn.classList.remove("on");
                    stopBtn.classList.add("on");
                    mVisuSwiper.autoplay.start();
                });

                window.scrollTo({top:0});
            }
        }

        onMounted(() => {

            // 영문 메뉴유형 설정 (session storage)
            sessionStorage.setItem('menuType', menuType.eng);

            // 최초 디자인 관련 초기화
            methods.designInit();

            state.isKorMenuOn = false;
            state.isEngMenuOn = true;

            // 최상단 메뉴 설정
            topMenu.value.setMenuItems(menuType.eng);

            // 메뉴맵 메뉴 설정
            menuMap.value.setMenuItems(menuType.eng);

            // 스크롤 이벤트 설정
            document.addEventListener('scroll', () => {
                
                const koreitHeaderElement = document.getElementById("eng-koreit-header");

                if (document.documentElement.scrollTop > 0) {

                    if (!koreitHeaderElement.classList.contains('scroll-on')) {

                        koreitHeaderElement.classList.add('scroll-on');
                    }
                }
                else koreitHeaderElement.classList.remove('scroll-on');
            });
        });
    
        return {
            state,
            eventHandler,
            methods,
            topMenu,
            menuMap,
        }
    },
}
</script>
<style>
    #eng-koreit-gnb > ul > li > ul > li > ul > li > router-link {
        display: block;
        width: 100%;
        font-size: 0.875em;
        color: #666;
        padding: 4px 0 4px 13px;
        position: relative;
    }

    #eng-all-gnb > ul > li > ul > li > ul > li > router-link {
        display: block;
        width: 100%;
        font-size: 0.875em;
        color: #666;
        padding: 4px 0 4px 13px;
        position: relative;
    }

    #eng-all-gnb > ul > li > ul > li > ul > li > router-link:before {
        content: '-';
        font-weight: 600;
        position: absolute;
        left: 0;
        top: 4px;
    }
</style>
